module.exports = __webpack_public_path__ + "resources/img/img_sqml_di1_en.a3ef907ce535581a6a1933cdf69987e4.png";